<script type="text/javascript">
import { mapState } from 'vuex';
import whatIsNewFlowVersion1 from './flows/what-is-new-flow-version-1/what-is-new-flow-version-1.vue';
import { VERSION_TO_MIGRATE_TO } from './helpers';

export default {
  components: {
    whatIsNewFlowVersion1,
  },
  computed: {
    ...mapState('profile', ['settings']),
    currentFlow() {
      if (VERSION_TO_MIGRATE_TO === 1) {
        return 'whatIsNewFlowVersion1';
      }
      return null;
    },
  },
};
</script>

<template>
  <div class="what-is-new-popup">
    <component :is="currentFlow" />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/what-is-new-popup/what-is-new-popup.vue